import React, { HTMLProps, RefCallback } from 'react';
import ReactSlider from 'react-slider';
import styles from './MinMaxSlider.module.css';
import cn from 'classnames';

interface HTMLPropsWithRefCallback<T> extends HTMLProps<T> {
    ref: RefCallback<T>;
}

type MinMaxSliderProps = {
    className?: string;
    min?: number;
    max?: number;
    minDistance?: number;
    stepSize?: number;
    values: [number, number];
    renderThumb?: (
        props: HTMLPropsWithRefCallback<HTMLDivElement>,
        state: {
            index: number;
            value: [number, number];
            valueNow: number;
        }
    ) => JSX.Element | null;
    onChange?: (value: [number, number], index?: number) => void;
    onAfterChange?: (value: [number, number], index?: number) => void;
};

const MinMaxSlider = ({
    className,
    min = 0,
    max = 100,
    stepSize,
    minDistance,
    values,
    onAfterChange,
    renderThumb,
    onChange,
}: MinMaxSliderProps) => {
    return (
        <ReactSlider
            className={cn(styles.container, className)}
            thumbActiveClassName={styles.thumbActive}
            trackClassName={styles.track}
            value={values}
            step={stepSize}
            min={min}
            max={max}
            onChange={onChange}
            onAfterChange={onAfterChange}
            renderThumb={renderThumb}
            minDistance={minDistance || stepSize || max / 10}
            withTracks
        />
    );
};

export default MinMaxSlider;
